/** ----------------数据字典 转化-------------**/
export default {
  // 图块type转typeDec
  switchBlockTypeDec(value) {
    switch (value) {
      case 'PLAN': return '_2d_俯'
      case 'ELEVATION': return '_2d_正'
      case 'PROFILE': return '_2d_侧'
      case 'System': return '_sys'
      case 'ThreeD': return '_3d'
      default: return ''
    }
  },
  // 根据图块名称typeDec转type
  switchBlockType(fileName) {
    const arr = fileName.split('.')
    const len = arr.length
    const suffix = arr[len - 1].toLowerCase()
    const restItem = arr.slice(0, len - 1)
    const splitName = restItem.join('.')
    let type = ''
    let typeDec = ''
    const lowerName = splitName.toLowerCase()
    if (lowerName.endsWith('_2d_俯')) {
      type = 'PLAN'
      typeDec = '_2d_俯'
    } else if (lowerName.endsWith('_2d_正')) {
      type = 'ELEVATION'
      typeDec = '_2d_正'
    } else if (lowerName.endsWith('_2d_侧')) {
      type = 'PROFILE'
      typeDec = '_2d_侧'
    } else if (lowerName.endsWith('_sys')) {
      type = 'System'
      typeDec = '_sys'
    } else if (lowerName.endsWith('_3d')) {
      type = 'ThreeD'
      typeDec = '_3d'
    } else if (suffix === 'xlsx') {
      type = 'PLAN'
    }
    return { suffix, type, typeDec }
  },
  // 图例类型转换
  switchPlaceholderMajor(value) {
    switch (value) {
      case 'COMMON': return '通用'
      case 'ELECTRIC': return '电气'
      default: return ''
    }
  },
  // 图例类型转换
  switchPlaceholderType(value) {
    switch (value) {
      case 'PROFILE': return '侧面'
      case 'ELEVATION': return '立面'
      case 'PLAN': return '平面'
      default: return ''
    }
  },
  // 状态转换
  switchStatus(value) {
    switch (value) {
      case 'PROCESSED_FAILED': return '处理失败'
      case 'PROCESSING': return '处理中'
      case 'TOBE_RELEASED': return '待发布'
      case 'RELEASED': return '已发布'
      default: return ''
    }
  },
}
